'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScheduledReportsContainerController = function () {
  function ScheduledReportsContainerController(authService, enums, loadingService, scheduledReportService, $stateParams, $ngConfirm, $scope, reportingService, userService, lookupService, growl) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ScheduledReportsContainerController);
    if (!authService.validateUser(false, 'Entity', enums.PERMISSION_TYPE.Edit, true)) {
      return;
    }

    this.authService = authService;
    this.enums = enums;
    this.loadingService = loadingService;
    this.scheduledReportService = scheduledReportService;
    this.$stateParams = $stateParams;
    this.$ngConfirm = $ngConfirm;
    this.$scope = $scope;
    this.reportingService = reportingService;
    this.userService = userService;
    this.lookupService = lookupService;
    this.growl = growl;

    this.$scope.reportParameterData = {};

    this.getAvailableReports();
    this.getLocationUsers();
    this.listScheduledReports();

    this.prepareReportParameters();
    this.prepareReportParametersData();
  }

  (0, _createClass3.default)(ScheduledReportsContainerController, [{
    key: 'listScheduledReports',
    value: function listScheduledReports() {
      var _this = this;

      this.loadingService.showLoading('scheduledReportsList', 'Loading Scheduled Reports ...');

      this.scheduledReportService.listScheduledReports(this.$stateParams.locationId).then(function (response) {
        _this.scheduledReports = response.data;
      }).finally(function () {
        _this.loadingService.hideLoading('scheduledReportsList');
      });
    }
  }, {
    key: 'getAvailableReports',
    value: function getAvailableReports() {
      var _this2 = this;

      this.reportingService.availableReportsByCategory(this.$stateParams.locationId, 1).then(function (response) {
        _this2.availableReports = response.data;
        var availableReportIdsForNow = [1, 2, 3, 11, 26];
        _this2.availableReports = (0, _lodash.filter)(_this2.availableReports, function (o) {
          return availableReportIdsForNow.includes(o.reportId);
        });
        var defaultItem = { reportId: null, name: 'Please Select' };
        _this2.availableReports = [defaultItem].concat((0, _toConsumableArray3.default)(_this2.availableReports));
      });
    }
  }, {
    key: 'getLocationUsers',
    value: function getLocationUsers() {
      var _this3 = this;

      this.userService.getLocationUsers(this.$stateParams.locationId, true).then(function (response) {
        _this3.locationUsers = response.data;
        _this3.locationUsers = (0, _lodash.sortBy)(_this3.locationUsers, function (o) {
          return o.firstName + ' ' + o.lastName;
        });
      });
    }
  }, {
    key: 'selectUsers',
    value: function selectUsers() {
      var _$scope$selectedUsers;

      var selUserIds = this.$scope.selAllUsers.map(function (r) {
        return r.userId;
      });
      var selUserItems = (0, _lodash.filter)(this.locationUsers, function (o) {
        return (0, _lodash.find)(selUserIds, function (uId) {
          return o.userId === uId;
        });
      });
      this.$scope.locationUsers = _lodash.without.apply(undefined, [this.$scope.locationUsers].concat((0, _toConsumableArray3.default)(selUserItems)));
      (_$scope$selectedUsers = this.$scope.selectedUsers).push.apply(_$scope$selectedUsers, (0, _toConsumableArray3.default)(selUserItems));
      this.$scope.selAllUsers = [];

      this.$scope.locationUsers = (0, _lodash.sortBy)(this.$scope.locationUsers, function (o) {
        return o.firstName + ' ' + o.lastName;
      });
      this.$scope.selectedUsers = (0, _lodash.sortBy)(this.$scope.selectedUsers, function (o) {
        return o.firstName + ' ' + o.lastName;
      });

      this.$scope.scheduledReport.recipients = this.$scope.selectedUsers.map(function (r) {
        return r.userId;
      });
    }
  }, {
    key: 'deSelectUsers',
    value: function deSelectUsers() {
      var _$scope$locationUsers;

      var selUserIds = this.$scope.selUsers.map(function (r) {
        return r.userId;
      });
      var selUserItems = (0, _lodash.filter)(this.$scope.selectedUsers, function (o) {
        return (0, _lodash.find)(selUserIds, function (uId) {
          return o.userId === uId;
        });
      });
      this.$scope.selectedUsers = _lodash.without.apply(undefined, [this.$scope.selectedUsers].concat((0, _toConsumableArray3.default)(selUserItems)));
      (_$scope$locationUsers = this.$scope.locationUsers).push.apply(_$scope$locationUsers, (0, _toConsumableArray3.default)(selUserItems));
      this.$scope.selUsers = [];

      this.$scope.locationUsers = (0, _lodash.sortBy)(this.$scope.locationUsers, function (o) {
        return o.firstName + ' ' + o.lastName;
      });
      this.$scope.selectedUsers = (0, _lodash.sortBy)(this.$scope.selectedUsers, function (o) {
        return o.firstName + ' ' + o.lastName;
      });

      this.$scope.scheduledReport.recipients = this.$scope.selectedUsers.map(function (r) {
        return r.userId;
      });
    }
  }, {
    key: 'convertEnumToKeyValueList',
    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
      var objList = [];

      if (defaultOption) {
        objList.push({
          id: null,
          name: 'Please Select'
        });
      }

      for (var prop in enumObj) {
        objList.push({
          id: enumObj[prop],
          name: prop
        });
      }

      return objList;
    }
  }, {
    key: 'showAdd',
    value: function showAdd() {
      this.$scope.errors = null;
      this.$scope.editMode = false;

      this.$scope.scheduledReport = {
        entityId: this.$stateParams.locationId,
        reportId: null,
        frequency: null,
        outputType: null,
        recipients: [],
        additionalRecipients: null,
        criteria: {}
      };

      this.$scope.reportsList = this.availableReports;
      this.$scope.frequencyList = this.convertEnumToKeyValueList(this.enums.SCHEDULED_REPORT_FREQUENCY, true);
      this.$scope.outputList = this.convertEnumToKeyValueList(this.enums.SCHEDULED_REPORT_OUTPUT_TYPE_TEMP, true);
      this.$scope.locationUsers = this.locationUsers;
      this.$scope.selAllUsers = [];
      this.$scope.selectedUsers = [];
      this.$scope.selUsers = [];
      this.$scope.reportTypeChanged = this.reportTypeChanged.bind(this);
      this.$scope.selectUsers = this.selectUsers.bind(this);
      this.$scope.deSelectUsers = this.deSelectUsers.bind(this);

      this.$ngConfirm({
        title: 'Add Scheduled Report',
        contentUrl: 'templates/reports/scheduledReportEditTemplate',
        typeAnimation: false,
        columnClass: 'l',
        scope: this.$scope,
        buttons: {
          yes: {
            text: 'Save Changes',
            btnClass: 'btn-success',
            action: this.add.bind(this)
          },
          no: {
            text: 'Cancel',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }, {
    key: 'add',
    value: function add() {
      var _this4 = this;

      if (!this.validateCriteria()) {
        return false;
      }

      this.loadingService.showLoading('scheduledReportsList', 'Adding Scheduled Report ...');

      this.$scope.scheduledReport.criteria = this.parseCriteria();

      this.scheduledReportService.add(this.$scope.scheduledReport).then(function (response) {
        _this4.scheduledReports.push(response.data);
        _this4.growl.success('Successfully added Scheduled Report', { ttl: 5000 });
      }).finally(function () {
        _this4.loadingService.hideLoading('scheduledReportsList');
      });
    }
  }, {
    key: 'showDelete',
    value: function showDelete(scheduledReport) {
      var _this5 = this;

      this.$ngConfirm({
        title: 'Delete Scheduled Report',
        content: 'Are you sure you want to delete this Scheduled Report ?',
        typeAnimation: false,
        scope: this.$scope,
        type: 'red',
        buttons: {
          yes: {
            text: 'Yes',
            btnClass: 'btn-danger',
            action: function action() {
              return _this5.delete(scheduledReport);
            }
          },
          no: {
            text: 'Leave it',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }, {
    key: 'delete',
    value: function _delete(scheduledReport) {
      var _this6 = this;

      this.loadingService.showLoading('scheduledReportsList', 'Removing Scheduled Report ...');

      this.scheduledReportService.delete(this.$stateParams.locationId, scheduledReport.scheduledReportId).then(function (response) {
        _this6.scheduledReports = (0, _lodash.without)(_this6.scheduledReports, scheduledReport);
        _this6.growl.success('Successfully removed Scheduled Report', { ttl: 5000 });
      }).finally(function () {
        _this6.loadingService.hideLoading('scheduledReportsList');
      });
    }
  }, {
    key: 'showEdit',
    value: function showEdit(scheduledReportId) {
      var _this7 = this;

      this.loadingService.showLoading('scheduledReportsList', 'Loading Scheduled Report ...');

      this.scheduledReportService.get(this.$stateParams.locationId, scheduledReportId).then(function (response) {
        _this7.showEditNext(response.data);
      }).finally(function () {
        _this7.loadingService.hideLoading('scheduledReportsList');
      });
    }
  }, {
    key: 'showEditNext',
    value: function showEditNext(scheduledReport) {
      var _this8 = this;

      this.$scope.errors = null;
      this.$scope.editMode = true;

      this.$scope.scheduledReport = {
        entityId: this.$stateParams.locationId,
        reportId: scheduledReport.reportId,
        frequency: scheduledReport.frequency,
        outputType: scheduledReport.outputType,
        recipients: [],
        additionalRecipients: scheduledReport.additionalRecipients,
        criteria: {}
      };

      this.$scope.reportsList = this.availableReports;
      this.$scope.frequencyList = this.convertEnumToKeyValueList(this.enums.SCHEDULED_REPORT_FREQUENCY, true);
      this.$scope.outputList = this.convertEnumToKeyValueList(this.enums.SCHEDULED_REPORT_OUTPUT_TYPE_TEMP, true);
      this.$scope.locationUsers = this.locationUsers;
      this.$scope.selAllUsers = [];
      this.$scope.selectedUsers = [];
      this.$scope.selUsers = [];
      this.$scope.selectedReportName = scheduledReport.reportName;
      this.$scope.reportTypeChanged = this.reportTypeChanged.bind(this);
      this.$scope.selectUsers = this.selectUsers.bind(this);
      this.$scope.deSelectUsers = this.deSelectUsers.bind(this);

      //Selected Recipients
      this.$scope.selAllUsers = scheduledReport.recipients.map(function (userId) {
        return { userId: userId };
      });
      this.selectUsers();

      //Update Criteria
      this.reportTypeChanged(JSON.parse(scheduledReport.criteria));

      this.$ngConfirm({
        title: 'Edit Scheduled Report',
        contentUrl: 'templates/reports/scheduledReportEditTemplate',
        typeAnimation: false,
        columnClass: 'l',
        scope: this.$scope,
        buttons: {
          yes: {
            text: 'Save Changes',
            btnClass: 'btn-success',
            action: function action() {
              return _this8.edit(scheduledReport.scheduledReportId);
            }
          },
          no: {
            text: 'Cancel',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }, {
    key: 'edit',
    value: function edit(scheduledReportId) {
      var _this9 = this;

      if (!this.validateCriteria()) {
        return false;
      }

      this.loadingService.showLoading('scheduledReportsList', 'Updating Scheduled Report ...');

      this.$scope.scheduledReport.criteria = this.parseCriteria();

      this.scheduledReportService.edit(scheduledReportId, this.$scope.scheduledReport).then(function (response) {
        var scheduledReport = (0, _lodash.find)(_this9.scheduledReports, function (o) {
          return o.scheduledReportId === response.data.scheduledReportId;
        });
        scheduledReport.frequency = response.data.frequency;
        scheduledReport.outputType = response.data.outputType;
        scheduledReport.recipients = response.data.recipients;

        _this9.growl.success('Successfully updated Scheduled Report', { ttl: 5000 });
      }).finally(function () {
        _this9.loadingService.hideLoading('scheduledReportsList');
      });
    }

    //Parameter Methods

  }, {
    key: 'prepareReportParameters',
    value: function prepareReportParameters() {
      var _this10 = this;

      this.reportParametersConfig = [{
        reportId: 1, //Showroom Traffic
        userLocations: true,
        userList: true,
        updateDefaults: function updateDefaults() {
          _this10.$scope.scheduledReport.criteria.location = _this10.$scope.reportParameterData.userLocations[0];
          _this10.$scope.reportParameterData.updateUserList();
        },
        editDefaults: function editDefaults(criteria) {
          if (criteria.LocationIds.length === _this10.$scope.reportParameterData.userLocations.length - 1) {
            _this10.$scope.scheduledReport.criteria.location = _this10.$scope.reportParameterData.userLocations[0];
          } else {
            _this10.$scope.scheduledReport.criteria.location = (0, _lodash.find)(_this10.$scope.reportParameterData.userLocations, function (o) {
              return o.id == criteria.LocationIds[0];
            });
          }

          _this10.updateUserList().then(function () {
            _this10.$scope.scheduledReport.criteria.user = (0, _lodash.find)(_this10.$scope.reportParameterData.userList, function (o) {
              return o.id == criteria.SalesRepId;
            });
          });
        }
      }, {
        reportId: 2, //All Enquiries
        userLocations: true,
        userList: true,
        brands: true,
        enquiryContact: true,
        enquiryStatus: true,
        updateDefaults: function updateDefaults() {
          _this10.$scope.scheduledReport.criteria.location = _this10.$scope.reportParameterData.userLocations[0];
          _this10.$scope.reportParameterData.updateUserList();

          _this10.$scope.scheduledReport.criteria.brand = _this10.$scope.reportParameterData.brands[0];
          _this10.$scope.reportParameterData.updateBrandModel();

          _this10.$scope.scheduledReport.criteria.enquiryContact = _this10.$scope.reportParameterData.enquiryContactList[2];
          _this10.$scope.scheduledReport.criteria.enquiryStatus = _this10.$scope.reportParameterData.enquiryStatusList[0];
        },
        editDefaults: function editDefaults(criteria) {
          if (criteria.LocationIds.length === _this10.$scope.reportParameterData.userLocations.length - 1) {
            _this10.$scope.scheduledReport.criteria.location = _this10.$scope.reportParameterData.userLocations[0];
          } else {
            _this10.$scope.scheduledReport.criteria.location = (0, _lodash.find)(_this10.$scope.reportParameterData.userLocations, function (o) {
              return o.id == criteria.LocationIds[0];
            });
          }

          _this10.updateUserList().then(function () {
            _this10.$scope.scheduledReport.criteria.user = (0, _lodash.find)(_this10.$scope.reportParameterData.userList, function (o) {
              return o.id == criteria.SalesRepId;
            });
          });

          _this10.$scope.scheduledReport.criteria.brand = (0, _lodash.find)(_this10.$scope.reportParameterData.brands, function (o) {
            return o.brandId == criteria.BrandId;
          });
          _this10.$scope.reportParameterData.updateBrandModel();
          _this10.$scope.scheduledReport.criteria.brandModel = (0, _lodash.find)(_this10.$scope.reportParameterData.brandModels, function (o) {
            return o.brandModelId == criteria.BrandModelId;
          });

          _this10.$scope.scheduledReport.criteria.enquiryContact = (0, _lodash.find)(_this10.$scope.reportParameterData.enquiryContactList, function (o) {
            return o.id == criteria.EnquiryContact;
          });
          _this10.$scope.scheduledReport.criteria.enquiryStatus = (0, _lodash.find)(_this10.$scope.reportParameterData.enquiryStatusList, function (o) {
            return o.id == criteria.EnquiryStatus;
          });
        }
      }, {
        reportId: 3, //Sales Report
        userLocations: true,
        userList: true,
        brands: true,
        enquiryContact: true,
        dateRangeType: true,
        updateDefaults: function updateDefaults() {
          _this10.$scope.scheduledReport.criteria.location = _this10.$scope.reportParameterData.userLocations[0];
          _this10.$scope.reportParameterData.updateUserList();

          _this10.$scope.scheduledReport.criteria.brand = _this10.$scope.reportParameterData.brands[0];
          _this10.$scope.reportParameterData.updateBrandModel();

          _this10.$scope.scheduledReport.criteria.enquiryContact = _this10.$scope.reportParameterData.enquiryContactList[2];
          _this10.$scope.scheduledReport.criteria.dateRangeType = _this10.$scope.reportParameterData.dateRangeTypeList[0];
        },
        editDefaults: function editDefaults(criteria) {
          if (criteria.LocationIds.length === _this10.$scope.reportParameterData.userLocations.length - 1) {
            _this10.$scope.scheduledReport.criteria.location = _this10.$scope.reportParameterData.userLocations[0];
          } else {
            _this10.$scope.scheduledReport.criteria.location = (0, _lodash.find)(_this10.$scope.reportParameterData.userLocations, function (o) {
              return o.id == criteria.LocationIds[0];
            });
          }

          _this10.updateUserList().then(function () {
            _this10.$scope.scheduledReport.criteria.user = (0, _lodash.find)(_this10.$scope.reportParameterData.userList, function (o) {
              return o.id == criteria.SalesRepId;
            });
          });

          _this10.$scope.scheduledReport.criteria.brand = (0, _lodash.find)(_this10.$scope.reportParameterData.brands, function (o) {
            return o.brandId == criteria.BrandId;
          });
          _this10.$scope.reportParameterData.updateBrandModel();
          _this10.$scope.scheduledReport.criteria.brandModel = (0, _lodash.find)(_this10.$scope.reportParameterData.brandModels, function (o) {
            return o.brandModelId == criteria.BrandModelId;
          });

          _this10.$scope.scheduledReport.criteria.enquiryContact = (0, _lodash.find)(_this10.$scope.reportParameterData.enquiryContactList, function (o) {
            return o.id == criteria.EnquiryContact;
          });
          _this10.$scope.scheduledReport.criteria.dateRangeType = (0, _lodash.find)(_this10.$scope.reportParameterData.dateRangeTypeList, function (o) {
            return o.id == criteria.DateRangeType;
          });
        }
      }, {
        reportId: 11, //Showroom Detailed
        userLocations: true,
        userList: true,
        updateDefaults: function updateDefaults() {
          _this10.$scope.scheduledReport.criteria.location = _this10.$scope.reportParameterData.userLocations[0];
          _this10.$scope.reportParameterData.updateUserList();
        },
        editDefaults: function editDefaults(criteria) {
          if (criteria.LocationIds.length === _this10.$scope.reportParameterData.userLocations.length - 1) {
            _this10.$scope.scheduledReport.criteria.location = _this10.$scope.reportParameterData.userLocations[0];
          } else {
            _this10.$scope.scheduledReport.criteria.location = (0, _lodash.find)(_this10.$scope.reportParameterData.userLocations, function (o) {
              return o.id == criteria.LocationIds[0];
            });
          }

          _this10.updateUserList().then(function () {
            _this10.$scope.scheduledReport.criteria.user = (0, _lodash.find)(_this10.$scope.reportParameterData.userList, function (o) {
              return o.id == criteria.SalesRepId;
            });
          });
        }
      }, {
        reportId: 26, //Weekly Sales Activity
        userLocations: true,
        updateDefaults: function updateDefaults() {
          _this10.$scope.scheduledReport.criteria.location = _this10.$scope.reportParameterData.userLocations[0];
        },
        editDefaults: function editDefaults(criteria) {
          if (criteria.LocationIds.length === _this10.$scope.reportParameterData.userLocations.length - 1) {
            _this10.$scope.scheduledReport.criteria.location = _this10.$scope.reportParameterData.userLocations[0];
          } else {
            _this10.$scope.scheduledReport.criteria.location = (0, _lodash.find)(_this10.$scope.reportParameterData.userLocations, function (o) {
              return o.id == criteria.LocationIds[0];
            });
          }
        }
      }];
    }
  }, {
    key: 'prepareReportParametersData',
    value: function prepareReportParametersData() {
      this.getUserLocations();
      this.getBrandsAndModels();
      this.getEnquiryContactList();
      this.getDateRangeTypeList();
      this.getEnquiryStatusList();
    }
  }, {
    key: 'reportTypeChanged',
    value: function reportTypeChanged(criteria) {
      var _this11 = this;

      this.$scope.selectedReportName = (0, _lodash.find)(this.availableReports, function (o) {
        return o.reportId == _this11.$scope.scheduledReport.reportId;
      }).name;
      this.$scope.reportParameters = (0, _lodash.find)(this.reportParametersConfig, function (o) {
        return o.reportId == _this11.$scope.scheduledReport.reportId;
      });

      if (!this.$scope.editMode) {
        this.$scope.reportParameters.updateDefaults();
      } else {
        this.$scope.reportParameters.editDefaults(criteria);
      }
    }
  }, {
    key: 'validateCriteria',
    value: function validateCriteria() {
      var _this12 = this;

      var errors = [];

      if (!this.$scope.scheduledReport.reportId) {
        errors.push('Please select a Report');
      }

      if (!this.$scope.scheduledReport.frequency) {
        errors.push('Please select Frequency');
      }

      if (!this.$scope.scheduledReport.outputType) {
        errors.push('Please select Output Type');
      }

      if (!this.$scope.scheduledReport.recipients.length) {
        errors.push('Please select at least one recipient');
      }

      if (this.$scope.scheduledReport.additionalRecipients) {
        var validEmails = true;
        this.$scope.scheduledReport.additionalRecipients.split(',').filter(function (element) {
          return element;
        }).map(function (eml) {
          return validEmails &= _this12.validateEmail(eml);
        });

        if (!validEmails) {
          errors.push('One or more emails mentioned in additional recipients are not valid');
        }
      }

      if (errors.length) {
        this.$scope.errors = errors;
        return false;
      }

      return true;
    }
  }, {
    key: 'parseCriteria',
    value: function parseCriteria() {
      var parsedCriteria = {};

      if (this.$scope.reportParameters.userLocations) {
        parsedCriteria.locationIds = this.getLocationIds();
      }

      if (this.$scope.reportParameters.userList) {
        parsedCriteria.salesRepId = this.$scope.scheduledReport.criteria.user.id;
      }

      if (this.$scope.reportParameters.brands) {
        parsedCriteria.brandId = this.$scope.scheduledReport.criteria.brand.brandId;
        parsedCriteria.brandModelId = this.$scope.scheduledReport.criteria.brandModel.brandModelId;
      }

      if (this.$scope.reportParameters.enquiryContact) {
        parsedCriteria.enquiryContact = this.$scope.scheduledReport.criteria.enquiryContact.id;
      }

      if (this.$scope.reportParameters.dateRangeType) {
        parsedCriteria.dateRangeType = this.$scope.scheduledReport.criteria.dateRangeType.id;
      }

      if (this.$scope.reportParameters.enquiryStatus) {
        parsedCriteria.enquiryStatus = this.$scope.scheduledReport.criteria.enquiryStatus.id;
      }

      return parsedCriteria;
    }
  }, {
    key: 'getUserLocations',
    value: function getUserLocations() {
      var userLocations = this.authService.authData.userLocations.map(function (l) {
        return { id: l.key, name: l.value };
      });

      userLocations.unshift({ id: null, name: 'All' });

      this.$scope.reportParameterData.userLocations = userLocations;
      this.$scope.reportParameterData.updateUserList = this.updateUserList.bind(this);
    }
  }, {
    key: 'getBrandsAndModels',
    value: function getBrandsAndModels() {
      var _this13 = this;

      this.lookupService.lookupBrands().then(function (brands) {
        brands.splice(0, 1);
        brands.unshift({ id: null, name: 'All' });
        _this13.$scope.reportParameterData.brands = brands;

        _this13.lookupService.lookupBrandModels().then(function (brandModels) {
          _this13.$scope.reportParameterData.allBrandModels = brandModels;
        });
      });

      this.$scope.reportParameterData.updateBrandModel = this.updateBrandModel.bind(this);
    }
  }, {
    key: 'getLocationIds',
    value: function getLocationIds() {
      var locationIds = void 0;

      if (!this.$scope.scheduledReport.criteria.location.id) {
        locationIds = (0, _lodash.filter)(this.$scope.reportParameterData.userLocations, function (o) {
          return o.id;
        }).map(function (ul) {
          return ul.id;
        });
      } else {
        locationIds = [this.$scope.scheduledReport.criteria.location.id];
      }

      return locationIds;
    }
  }, {
    key: 'updateUserList',
    value: function updateUserList() {
      var _this14 = this;

      this.loadingService.showLoading('scheduledReportsList', 'Updating Sales Rep List ...');

      var src = this.userService.getEntityUsers(this.getLocationIds());

      src.then(function (response) {
        var userList = response.data.map(function (i) {
          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
        });
        userList.unshift({ id: null, name: 'All' });

        _this14.$scope.reportParameterData.userList = userList;

        _this14.$scope.scheduledReport.criteria.user = userList[0];
      }).finally(function () {
        _this14.loadingService.hideLoading('scheduledReportsList');
      });

      return src;
    }
  }, {
    key: 'updateBrandModel',
    value: function updateBrandModel() {
      var _this15 = this;

      this.$scope.reportParameterData.brandModels = (0, _lodash.filter)(this.$scope.reportParameterData.allBrandModels, function (o) {
        return o.brandId === _this15.$scope.scheduledReport.criteria.brand.brandId;
      });
      this.$scope.reportParameterData.brandModels.unshift({ id: null, name: 'All' });
      this.$scope.scheduledReport.criteria.brandModel = this.$scope.reportParameterData.brandModels[0];
    }
  }, {
    key: 'getEnquiryContactList',
    value: function getEnquiryContactList() {
      this.$scope.reportParameterData.enquiryContactList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_CONTACT);
      this.$scope.reportParameterData.enquiryContactList.unshift({ id: null, name: 'All' });
    }
  }, {
    key: 'getDateRangeTypeList',
    value: function getDateRangeTypeList() {
      this.$scope.reportParameterData.dateRangeTypeList = [];
      this.$scope.reportParameterData.dateRangeTypeList.push({ id: 'confirmeddate', name: 'Confirmed Date' });
      this.$scope.reportParameterData.dateRangeTypeList.push({ id: 'deliverydate', name: 'Delivery Date' });
    }
  }, {
    key: 'getEnquiryStatusList',
    value: function getEnquiryStatusList() {
      this.$scope.reportParameterData.enquiryStatusList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_STATE);
      this.$scope.reportParameterData.enquiryStatusList.unshift({ id: null, name: 'All' });
    }
  }, {
    key: 'validateEmail',
    value: function validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  }]);
  return ScheduledReportsContainerController;
}();

exports.default = ScheduledReportsContainerController;


// WEBPACK FOOTER //
// ./client/app/components/admin/scheduledReportsManagement/scheduledReportsContainer/scheduledReportsContainer.controller.js